import { ROUTE_PATH, regions, genderList, statusList, Attendance_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmDatepickerModel, SmMetaSelectModel } from "common/models/utility-models/meta-model";

export class CompiledFilterMetaModel extends FormMetaModel {
    constructor() {
        super('', ROUTE_PATH.reports, ROUTE_PATH.reports, 3, null,false,'','','row align-items-start' );
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const selectedBatch = new SmMetaSelectModel(
            'selectedBatch',
            'selectedBatch',
            'select',
            false,
            'col-2-4',
            1,
            1,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'batch_number',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true

        );
        const selectedRegion = new SmMetaSelectModel(
            'selectedRegion',
            'selectedRegion',
            'select',
            false,
            'col-2-4',
            1,
            2,
            'Region',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            regions,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedState = new SmMetaSelectModel(
            'selectedState',
            'selectedState',
            'select',
            false,
            'col-2-4',
            1,
            3,
            'State',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'stateName',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedBranch = new SmMetaSelectModel(
            'selectedBranch',
            'selectedBranch',
            'select',
            false,
            'col-2-4',
            1,
            4,
            'Branch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'department_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedGender = new SmMetaSelectModel(
            'selectedGender',
            'selectedGender',
            'select',
            false,
            'col-2-4',
            1,
            5,
            'Gender',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            genderList,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedStatus = new SmMetaSelectModel(
            'selectedStatus',
            'selectedStatus',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            6,
            'Status',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            statusList,
            'name',
            'value',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        const selectedLocation = new SmMetaSelectModel(
            'selectedLocation',
            'selectedLocation',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            7,
            'Location',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'city_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        const selectedType = new SmMetaSelectModel(
            'selectedType',
            'selectedType',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            7,
            'Type',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'type_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        const selectedCategory = new SmMetaSelectModel(
            'selectedCategory',
            'selectedCategory',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            7,
            'Category',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'category_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );
        const selectedAttended = new SmMetaSelectModel(
            'selectedAttended',
            'selectedAttended',
            'select',
            false,
            'col-2-4 pt-2',
            1,
            8,
            'Attendance',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            Attendance_OPTIONS,
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            true
        );

        const selectedFromDate = new SmDatepickerModel(
            'selectedFromDate',
            'selectedFromDate',
            'datepicker',
            false,
            'col-2-4 pt-2',
            1,
            9,
            'Start',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
        );


        const selectedToDate = new SmDatepickerModel(
            'selectedToDate',
            'selectedToDate',
            'datepicker',
            false,
            'col-2-4 pt-2',
            1,
            10,
            'End',
            'text',
            '',
            true,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
        );


        // const buttons = {
        //     // submit: new SmBtnMetaModel('Submit', '', true, false, false, true),
        //     isFormControl: false,
        // };


        return {
            formInfo,
            selectedBatch,
            selectedBranch,
            selectedGender,
            selectedRegion,
            selectedState,
            selectedStatus,
            selectedLocation,
            selectedType,
            selectedCategory,
            selectedAttended,
            selectedFromDate,
            selectedToDate
        }
    }
}